import { render, staticRenderFns } from "./statements-filter.vue?vue&type=template&id=5fc29480"
import script from "./statements-filter.vue?vue&type=script&lang=js"
export * from "./statements-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports